import { useSelector } from "react-redux";
import { uploadCategory } from "../constants/constants";

/**
 * True while any file is between pre_flight and a finished post_flight for this
 * revision's content uploads.
 *
 * Submitting with a file still in flight loses that file: the backend never
 * blocks submit, and a file that has not finished is simply not added (its next
 * chunk call comes back 409 `revision_submitted`). So the guard is a UI rule -
 * "Send Request" waits for the uploads rather than the server refusing it.
 *
 * `selected_files` and `upload_status` are parallel arrays filled by the upload
 * hook, so a file is matched to its status by index. A file with no status yet
 * has only just been dropped, which counts as in flight.
 *
 * @param {number} revisionId only uploads aimed at this revision count
 */
export default (revisionId) => {
  const uploadReducer = useSelector((state) => state.root.uploadReducer);

  const selectedFiles = Array.isArray(uploadReducer?.selected_files) ? uploadReducer.selected_files : [];
  const statuses = Array.isArray(uploadReducer?.upload_status) ? uploadReducer.upload_status : [];

  return selectedFiles.some((file, index) => {
    if (file?.category !== uploadCategory.revisionContent) return false;
    // A revision id is carried on every revision-content upload; when one is
    // asked about, uploads for other revisions are somebody else's problem.
    if (revisionId && file?.extraPayload?.revision_id && file.extraPayload.revision_id !== revisionId) return false;
    const status = statuses[index];
    // 'success' and 'error' are both terminal; anything else is still running.
    return !status || (status?.type !== 'success' && status?.type !== 'error');
  });
};
